<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<div class="centerfull">
<img alt="" src="image/Cradle_coverbuildingonly_Grayscale.jpg"/>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// x9781541541771-1.vue?74c338a8